/**
 * System accounts (decision 540; docs/specs/cloud/system-accounts.md): accounts Braynewave runs inside a tenant, such
 * as the automatic live tests' "Teslyn live check (system)" field crew member. The database leaves them out of
 * every list a tenant sees (`member_visible`, migration 20261025000800); a platform admin still sees them, and every
 * screen names them "System" so nobody mistakes one for a person.
 */

/** What a system account is called wherever a platform admin sees it. */
export const SYSTEM_ACCOUNT_WORD = 'System';

export interface AccountNameParts {
  readonly display_name?: string | null;
  readonly email?: string | null;
  readonly system?: boolean | null;
}

/** "Jane Smith", "jane@example.com", "System (Teslyn live check (system))" or "Unnamed user". */
export function accountLabel(u: AccountNameParts | null | undefined): string {
  const name = u?.display_name?.trim() || u?.email?.trim() || '';
  if (u?.system) return name ? `${SYSTEM_ACCOUNT_WORD} (${name})` : SYSTEM_ACCOUNT_WORD;
  return name || 'Unnamed user';
}

/** The accounts a person may be linked to or chosen from: never a system account. */
export function withoutSystemAccounts<T extends { readonly system?: boolean | null }>(
  rows: readonly T[],
): T[] {
  return rows.filter((r) => !r.system);
}
